var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox",style:({ '--size': `${_vm.size}px` })},[_c('input',{staticClass:"checkbox__input",attrs:{"name":"checkbox","id":_vm.id,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('label',{staticClass:"checkbox__label",attrs:{"for":_vm.id}},[_vm._t("label")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }